import axios from 'axios';

const clienteAxios = axios.create({
    baseURL: 'https://metodoyogen.com/api'
});

export default clienteAxios;